import ResyRewards, { ComponentResyRewardsUnderTest } from './ResyRewards';

export default ResyRewards;

export { ComponentResyRewardsUnderTest };
